<script setup lang="ts">
import IconTicket from '../icons/IconTicket.vue'
import IconTicketStar from '../icons/IconTicketStar.vue'
import IconWinners from '../icons/IconWinners.vue'
</script>

<template>
  <AppSection aria-labelledby="quick-links-label" class="pb-3 @md/main:!pt-8">
    <span id="quick-links-label" class="sr-only">
      Explore our most popular features and prizes.
    </span>

    <div
      class="-mx-3 gap-2 overflow-x-auto bg-white px-3 @md/main:px-0 @md/main:-mx-0 flex scrollbar-none"
    >
      <div class="quick-link-border flex-1">
        <RouterLink
          :to="{
            name: 'prizes',
            query: { tab: 'instant-prizes', switch: 'instant-wins' },
          }"
          class="quick-link-card hover:bg-primary-lighter"
        >
          <p class="flex items-center gap-2 whitespace-nowrap">
            <IconTicketStar />Instant Prizes
          </p>
        </RouterLink>
      </div>

      <div class="quick-link-border flex-1 hover:bg-primary-lighter">
        <RouterLink
          :to="{
            name: 'prizes',
            query: { tab: 'featured-wins' },
          }"
          class="quick-link-card hover:bg-primary-lighter"
        >
          <p class="flex items-center gap-2 whitespace-nowrap">
            <AppIcon :icon="$t('section.featured_prizes.heading_icon')" />
            {{ $t('section.featured_prizes.heading') }}
          </p>
        </RouterLink>
      </div>

      <div class="quick-link-border flex-1">
        <RouterLink
          :to="{ name: 'benefits' }"
          class="quick-link-card hover:bg-primary-lighter"
        >
          <p class="flex items-center gap-2 whitespace-nowrap">
            <IconTicket />Benefits
          </p>
        </RouterLink>
      </div>

      <div class="quick-link-border flex-1">
        <RouterLink
          :to="{ name: 'results-and-winners' }"
          class="quick-link-card hover:bg-primary-lighter"
        >
          <p class="flex items-center gap-2 whitespace-nowrap">
            <IconWinners />Latest Winners
          </p>
        </RouterLink>
      </div>
    </div>
  </AppSection>
</template>

<style lang="scss" scoped>
.quick-link-border {
  @apply rounded-[1000px] p-[3px] transition-transform duration-200;
  @apply bg-gradient-to-r from-primary via-slate-900 to-primary;
}

.quick-link-card {
  @apply flex flex-1 flex-col items-center gap-1 justify-center rounded-[1000px] bg-pure-white px-3 py-1 md:px-4 md:py-2 text-center transition-colors duration-200 size-full;

  img {
    @apply h-10 w-auto md:h-20;
  }

  p {
    @apply font-bold leading-5 md:text-xl md:leading-6;
  }
}
</style>
